import { render, staticRenderFns } from "./teamIntroduction.vue?vue&type=template&id=4ed3a071&scoped=true"
import script from "./teamIntroduction.vue?vue&type=script&lang=js"
export * from "./teamIntroduction.vue?vue&type=script&lang=js"
import style0 from "./teamIntroduction.vue?vue&type=style&index=0&id=4ed3a071&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed3a071",
  null
  
)

export default component.exports